export const PERMISSIONS = {
     CAN_EDIT_NOTE: 'can_edit_note',
     /** Supprimer une Note */
     CAN_DELETE_NOTE: 'can_delete_note',

     /** Modifier un Accord de Paiement */
     CAN_EDIT_PAYMENT_AGREEMENT: "can_edit_payment_agreement",
     /** Supprimer un Accord de Paiement */
     CAN_DELETE_PAYMENT_AGREEMENT: 'can_delete_payment_agreement',

     /** Modifier un Document */
     CAN_EDIT_DOCUMENT: 'can_edit_document',
     /** Supprimer un Document */
     CAN_DELETE_DOCUMENT: 'can_delete_document',
     /** Voir les Documents Supprimés */
     CAN_SHOW_DELETED_DOCUMENTS: 'can_show_deleted_documents',

     /** Voir les Événements */
     CAN_SHOW_EVENTS: 'can_show_events',

     /** Voir les Activités */
     CAN_SHOW_ACTIVITIES: 'can_show_activities',

     /** Voir les Paramètres Avancés */
     CAN_SHOW_ADVANCED_SETTINGS: 'can_show_advanced_settings',

     /** Voir les Debugs */
     CAN_SHOW_DEBUG: 'can_show_debug',

     /** Modifier une Transaction */
     CAN_EDIT_TRANSACTION: 'can_edit_transaction',
     /** Supprimer une Transaction */
     CAN_DELETE_TRANSACTION: 'can_delete_transaction',
     /** Voir le Détail d'une Transaction */
     CAN_SHOW_TRANSACTION_DETAIL: 'can_show_transaction_detail',
     /** Exporter les Transactions */
     CAN_EXPORT_TRANSACTION: 'can_export_transaction',

     /** Traiter un Justificatif */
     CAN_VALIDATE_SUPPORTING_DOCUMENT: 'can_validate_supporting_document',

     /** Gérer un Avenant */
     CAN_MAKE_AMENDMENT: 'can_make_amendment',

     /** Gérer une Résiliation */
     CAN_MAKE_TERMINATION: 'can_make_termination',

     /** Gérer un Moyen de Paiement */
     CAN_LINK_PAYMENT_AGREEMENT: 'can_link_payment_agreement',
     /** Créer un Paiement */
     CAN_CREATE_MANUAL_PAYMENT: 'can_create_manual_payment',
 
     /** Réclamations */
     COMPLAIN_LIST: 'complain_list',
     CAN_CREATE_COMPLAIN_LVL_1: 'can_create_complain_lvl_1',
     CAN_CREATE_COMPLAIN_LVL_2: 'can_create_complain_lvl_2',
     CAN_CREATE_COMPLAIN_LVL_3: 'can_create_complain_lvl_3',
     CAN_CREATE_COMPLAIN_SENSIBLE: 'can_create_complain_sensible',
     CAN_CREATE_COMPLAIN_PAYMENT: 'can_create_complain_payment',

     /** Accès Espace Client */
     CAN_ACCESS_CUSTOMER_SPACE: 'can_access_customer_space',

     /** Bypass Acompte */
     CAN_BYPASS_INSTALLMENT: 'can_bypass_installment',

     /** Annuler un contrat */
     CAN_CANCEL_CONTRACT: 'can_cancel_contract',

     /** Signer un contrat */
     CAN_SIGN_CONTRACT: 'can_sign_contract',

     /** Marquer un contrat comme Brouillon */
     CAN_MARKS_AS_DRAFT: 'can_marks_as_draft',

     /** Client Liste */
     CUSTOMER_LIST: 'customer_list',
     /** Client Bouton Actions */
     CUSTOMER_VIEW_ACTIONS_BUTTON: 'customer_view_actions_button',
     /** Client Onglet Utilisateur */
     CUSTOMER_VIEW_USER_TAB: 'customer_view_user_tab',
     /** Client Onglet Document */
     CUSTOMER_VIEW_DOCUMENT_TAB: 'customer_view_document_tab',
     /** Client Onglet Paiement */
     CUSTOMER_VIEW_PAYMENT_TAB: 'customer_view_payment_tab',
     /** Client Onglet Doublon */
     CUSTOMER_VIEW_DUPLICATE_TAB: 'customer_view_duplicate_tab',
     /** Client Onglet Connexion */
     CUSTOMER_VIEW_CONNEXION_TAB: 'customer_view_connexion_tab',

     /** Devis Liste */
     QUOTE_LIST: 'quote_list',
     /** Devis Bouton Actions */
     QUOTE_VIEW_ACTIONS_BUTTON: 'quote_view_actions_button',

     /** Police Liste */
     POLICY_LIST: 'policy_list',
     /** Police Bouton Actions */
     POLICY_VIEW_ACTIONS_BUTTON: 'policy_view_actions_button',
     /** Police Bouton Document */
     POLICY_VIEW_DOCUMENT_BUTTON: 'policy_view_document_button',
     /** Police Onglet Echéancier */
     POLICY_VIEW_SCHEDULE_TAB: 'policy_view_schedule_tab',

     /** Justificatif Liste */
     SUPPORTING_DOCUMENT_LIST: 'supporting_document_list',
     /** Justificatif Bouton Assigner */
     SUPPORTING_DOCUMENT_VIEW_ASSIGN_BUTTON: 'supporting_document_view_assign_button',
     /** Justificatif Bouton Actions */
     SUPPORTING_DOCUMENT_VIEW_ACTIONS_BUTTON: 'supporting_document_view_actions_button',

     /**  Sinistre Liste */
     CLAIM_LIST: 'claim_list',

     /** Demande Liste */
     REQUEST_LIST: 'request_list',

     /** Facturation Navbar Onglet */
     BILLING_NAVBAR_TAB: 'billing_navbar_tab',

     /** Admin */
     ADMIN: 'admin'
}